import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BbitWebShopAlgoliaService, BbitWebShopNotificationService } from '@bbitgmbh/webshop.sdk';
import { BbitCookieState, BbitGdprService, I18nPipe } from '@bbitgmbh/website.sdk';
import { NgIcon } from '@ng-icons/core';
import { DateTime } from 'luxon';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from './api/api.service';
import { INewsEntry } from './api/news.interfaces';
import { CategoryService } from './category/category.service';
import { FooterComponent } from './footer/footer.component';
import { NavComponent } from './nav/nav.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavComponent, NgIcon, RouterOutlet, FooterComponent, AsyncPipe, I18nPipe],
})
export class AppComponent implements OnInit {
  // biome-ignore lint/correctness/noUnusedPrivateClassMembers: do not remove this
  private _algolia = inject(BbitWebShopAlgoliaService); // do not remove this
  notification = inject(BbitWebShopNotificationService);
  private _api = inject(ApiService);
  // biome-ignore lint/correctness/noUnusedPrivateClassMembers: do not remove this, it is required to update the urls
  private _category = inject(CategoryService); // do not remove this, it is required to update the urls
  gdpr = inject(BbitGdprService);
  public highlightedNewsEntry = new BehaviorSubject<INewsEntry | undefined>(undefined);
  public highlightedNewsHtml = signal<string>('');
  public showNotification = new BehaviorSubject<boolean>(false);
  public BbitCookieState = BbitCookieState;
  public language = signal<'de' | 'en'>('de');

  constructor() {
    if (!localStorage.getItem('bbitHideMove2024Notification')) {
      this.showNotification.next(false);
    }
  }

  async ngOnInit() {
    const allNews: any[] = await this._api.getNews();

    console.log('arsch', allNews);

    const news = allNews
      .filter((o) => {
        if (!o.showOnHomePage) {
          return false;
        }

        const showUntilIso = o.showOnHomePageUntil || o.showUntil;
        if (showUntilIso) {
          const showUntil = DateTime.fromISO(showUntilIso);
          if (showUntil.isValid) {
            return showUntil >= DateTime.now();
          }
        }

        return true;
      })
      .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
    const highlightedNewsEntry = news?.[0];
    if (highlightedNewsEntry) {
      this.highlightedNewsEntry.next(highlightedNewsEntry);
      if (!localStorage.getItem(`bbitHighlightedNewsEntry${highlightedNewsEntry._id}`)) {
        this.showNotification.next(true);
      }
    }
  }

  closeNotification() {
    this.showNotification.next(false);
    localStorage.setItem(`bbitHighlightedNewsEntry${this.highlightedNewsEntry?.value?._id}`, 'true');
  }
}
